export default __webpack_public_path__ + "static/media/tree.d109a325.png";